import { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';

import { ExpenseItem } from './ExpenseItem.tsx';
import { expenseListOrder } from './expenseTypeConfig.ts';
import type { ExpensesFormState } from '../hooks/useExpensesForm.ts';
import { useLeadDetailsFormContext } from '~/features/leadDetails/context/LeadDetailsFormContext.tsx';
import type { SchemaExpensesForm } from '~/features/leadDetails/schemas/expenses.schema.ts';

type Props = {
    applicant: 1 | 2;
    onDelete: ExpensesFormState['onDelete'];
};

export const ExpensesApplicant: React.FC<Props> = ({ applicant, onDelete }) => {
    const { watch } = useFormContext<SchemaExpensesForm>();
    const { addedRowIds } = useLeadDetailsFormContext();
    const attribution =
        applicant === 2 ? APPLICANT_ATTRIBUTIONS.ANTRAGSTELLER_2 : APPLICANT_ATTRIBUTIONS.ANTRAGSTELLER_1;
    const expenses = watch();

    const rows = expenseListOrder
        .flatMap((type) => (expenses[type] ?? []).map((expense, index) => ({ ...expense, index, type })))
        .filter((row) => row.gehoertZuAntragsteller === attribution)
        // Rows without an entry in addedRowIds score -1 and keep the order of expenseListOrder,
        // rows the user added in this session follow in the order the user added them.
        .sort((a, b) => addedRowIds.indexOf(a.id) - addedRowIds.indexOf(b.id));

    return (
        <div className="space-y-2">
            {rows.map(({ id, index, type }) => (
                <ExpenseItem
                    key={id}
                    id={id}
                    index={index}
                    isSecondApplicant={applicant === 2}
                    onDelete={onDelete}
                    type={type}
                />
            ))}
        </div>
    );
};
